import React, { Component } from 'react';
import { string } from '../../localization';
import { Icons } from '../../utilities';
import './PostersDone.scss';
import { Button } from 'reactstrap';
import Preview from '../VanillaDesign/VanillaFinalCheck/Preview';
import '../VanillaDesign/VanillaFinalCheck/VanillaFinalCheck.scss';
import MessageDialogue from '../MessageDialogue/MessageDialogue';
import { Modal } from 'reactstrap';
import { connect } from 'react-redux';
import { openLinkInCurrentTab } from '../../utilities/HelperFunctions/HelperFunctions';
import * as Constants from '../../utilities/constants/Constants';
import FeedbackDialogue from '../FeedbackDialogue/FeedbackDialogue';
import * as CookieUtils from '../../utilities/CookieUtils/CookieUtils';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';

class PostersDone extends Component {
  state = {
    showIframe: false,
    socialMediaUrl: ''
  };

  componentDidMount() {
    const {
      feedbackDuration,
      feedbackState,
      isFeedbackVisible,
      dispatchers
    } = this.props;
    const shouldShowFeedback = CookieUtils.resumeFeedbackCookie(
      feedbackDuration
    );
    if (
      (shouldShowFeedback === undefined || !shouldShowFeedback) &&
      feedbackState &&
      isFeedbackVisible
    ) {
      dispatchers.fabricCanvasActions.setFeedbackDialogue(true);
    }
  }

  renderPreviw = () => {};

  socialMediaShareHandler = socialMedia => {
    this.setState({
      showIframe: true,
      socialMediaUrl: socialMedia
    });
  };

  closeIframe = () => {
    this.setState({
      showIframe: false
    });
  };

  handleMyWork = () => {
    openLinkInCurrentTab(Constants.MY_WORK);
  };

  stopTimer = () => {
    clearInterval(this.interval);
  };

  createNewProject = () => {
    const { createNew, dispatchers } = this.props;

    createNew(Constants.SIZE_SELECTION_PAGE);
    dispatchers.fabricCanvasActions.sendReviewOrderGA(true);
  };

  render() {
    const { orientation, id, showFeedbackDialogue } = this.props;
    const { showIframe, socialMediaUrl } = this.state;

    return (
      <div
        className={`vanilla-final-check d-flex ${
          orientation == 'Landscape' ? 'landscape-style' : 'potrait-style'
        }`}
      >
        <Preview />
        {/* <div id="overlay" /> */}
        {showIframe && (
          <Modal
            className='modalContainer'
            isOpen={showIframe}
            backdrop={false}
          >
            <div>
              <div className='closeModalIcn'>
                <button
                  type='button'
                  className='closeButton'
                  onClick={this.closeIframe}
                >
                  <img className='closeModal' alt='close' src={Icons.close} />
                </button>
              </div>
              <iframe
                title='media'
                className='showIframe'
                frameBorder='0'
                src={`${socialMediaUrl}?project_id=${id}`}
              />
            </div>
          </Modal>
        )}
        <div className='poster-done'>
          <div className='poster-done-status'>
            <span>
              <img src={Icons.done_button} alt='' />
            </span>
            <div className='poster-done-status-msg'>
              <span className='poster-done-txt'>{string.DONE}</span>
              <span className='poster-file-txt'>{string.STATUS_MSG}</span>
            </div>
          </div>

          <div className='poster-done-content'>
            <div className='poster-done-create-new'>
              <Button
                className='rounded-0 border-0 create-new'
                block
                onClick={this.createNewProject}
              >
                {string.CREATE_NEW}
              </Button>
              <span className='poster-done-text'>
                {string.YOU_CAN_ALWAYS_ACCESS}{' '}
                <button
                  type='button'
                  style={{
                    border: 'none',
                    background: 'none',
                    outline: 'none'
                  }}
                  className='mywork-txt'
                  onClick={this.handleMyWork}
                >
                  {string.MY_WORK_KEY}
                </button>
              </span>
            </div>
            <div className='poster-done-share'>
              <span className='poster-done-share-lbl'>
                {string.SHARE_YOUR_CREATION}
              </span>
              <span className='share-icons share-imgs'>
                <button
                  type='button'
                  style={{
                    border: 'none',
                    outline: 'none'
                  }}
                  aria-label='facebook'
                  onClick={() =>
                    this.socialMediaShareHandler('facebook_connect')
                  }
                  className='share-imgs facebook'
                />
                <button
                  type='button'
                  style={{
                    border: 'none',
                    outline: 'none'
                  }}
                  aria-label='twitter'
                  onClick={() => this.socialMediaShareHandler('twitter')}
                  className='share-imgs twitter'
                />
                <button
                  type='button'
                  style={{
                    border: 'none',
                    outline: 'none'
                  }}
                  aria-label='pinterest'
                  onClick={() => this.socialMediaShareHandler('pinterest')}
                  className='share-imgs pintrest'
                />
                <button
                  type='button'
                  style={{
                    border: 'none',
                    outline: 'none'
                  }}
                  aria-label='linkedin'
                  onClick={() => this.socialMediaShareHandler('linked_in')}
                  className='share-imgs linkedin'
                />
              </span>
              {showFeedbackDialogue ? (
                <FeedbackDialogue onDisplay={this.stopTimer} />
              ) : null}
              <MessageDialogue />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    id: state.finalCheck.project.id,
    orientation: state.home.orientation,
    feedbackDuration: state.modal.envData.feedback_duration,
    isFeedbackVisible: state.modal.storeData.showFeedback,
    showFeedbackDialogue: state.fabricCanvas.showFeedbackDialogue,
    feedbackState: state.fabricCanvas.feedbackState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PostersDone);
